import React, { useState } from 'react';
import { IconChevronDown } from '../components/Icons';

const faqItems = [
  {
    num: '01',
    q: 'How much do bookkeeping services in Dubai cost?',
    a: 'It depends on your monthly transaction volume. We fix one monthly fee after a 15-minute call, and it only changes if your volume does.',
  },
  {
    num: '02',
    q: 'Do free zone companies in Dubai need bookkeeping?',
    a: 'Yes. Mainland and free zone companies both need to keep proper accounting records. We work with both.',
  },
  {
    num: '03',
    q: 'Can you take over from our current accountant?',
    a: 'Yes. We request the records from them and take over within about 14 days.',
  },
  {
    num: '04',
    q: 'Our accounts are months behind. Can you fix that?',
    a: 'Yes. Backlog accounting is scoped once, finished first, then monthly bookkeeping starts clean.',
  },
  {
    num: '05',
    q: 'Is there a contract?',
    a: 'No lock-in. The fee is monthly and you can leave any month.',
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0); // 01 is open by default

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="bk-faq" id="faq" data-screen-label="FAQ">
      <div className="bk-container">
        <header className="bk-faq-head">
          <span className="bk-pill bk-pill--peach">
            <span className="bk-dot" aria-hidden="true" />
            [ Frequently asked questions ]
          </span>
          <h2 className="bk-h2 bk-h2--xl bk-h2--bold">
            Bookkeeping in Dubai: <span className="bk-accent">common questions</span>
          </h2>
        </header>

        <div className="bk-faq-list">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.num} className={`bk-faq-item ${isOpen ? 'is-open' : ''}`}>
                <h3 className="bk-faq-q">
                  <button
                    type="button"
                    onClick={() => handleToggle(index)}
                    className="bk-faq-trigger"
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${item.num}`}
                    id={`faq-question-${item.num}`}
                  >
                    <span className="bk-faq-num">{item.num}</span>
                    <span className="bk-faq-q-text">{item.q}</span>
                    <span className="bk-faq-toggle" aria-hidden="true">
                      <IconChevronDown size={14} />
                    </span>
                  </button>
                </h3>

                {isOpen && (
                  <div
                    className="bk-faq-answer"
                    id={`faq-answer-${item.num}`}
                    role="region"
                    aria-labelledby={`faq-question-${item.num}`}
                  >
                    <p>{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
